import Pusher from "pusher-js";
import { useEffect, useState } from "react";
import { useAuth } from "../../providers/Auth";
import api from "../../services/api";
import { Chatbox } from "./styles";

interface IMessage {
  message: string;
  username: string;
}

const Chat = () => {
  const [message, setMessage] = useState("");
  const [messages, setMessages] = useState([] as IMessage[]);
  const { accessToken, user } = useAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (message.length > 0) {
      await api.post(
        "/chat",
        { message, username: user.username },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );
      setMessage("");
    }
  };

  useEffect(() => {
    Pusher.logToConsole = true;

    const pusher = new Pusher("050c0e922164c5c7d59b", {
      cluster: "sa1",
    });

    const channel = pusher.subscribe("chat");
    channel.bind("message", function (data: IMessage) {
      setMessages((previous) => {
        if (
          (data.message !== previous[previous.length - 1]?.message &&
            data.username !== previous[previous.length - 1]?.username) ||
          data.message !== previous[previous.length - 1].message
        ) {
          return [...previous, data];
        }
        return previous;
      });
    });

    return () => {
      pusher.unsubscribe("chat");
    };
  }, []);

  return (
    <Chatbox>
      <div className="messages">
        {messages.map((message, index) => (
          <div key={index}>
            <p>
              <strong>{message.username}:</strong> {message.message}
            </p>
          </div>
        ))}
      </div>
      <form onSubmit={(e) => handleSubmit(e)}>
        <input
          type="text"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        />
        <button type="submit">Send</button>
      </form>
    </Chatbox>
  );
};

export default Chat;
